export enum EFeedbackScreen {
  Form,
  Thanks,
}

export interface ISendFeedbackParams {
  name: string;
  phone: string;
  comment: string;
}

export interface IFeedbackState {
  screen: EFeedbackScreen;
  isLoading: boolean;
  isSendError: boolean;
  topPosition: number;
  height: number;
  isVisibleForm: boolean | null;
}
